import axios from "axios";
import { buildHeaders } from "@/services/_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}jobs/`;

export default {
  list(params = {}) {
    return axios.get(API_URL, { params, headers: buildHeaders() });
  },
  show(id) {
    return axios.get(`${API_URL}${id}`, { headers: buildHeaders() });
  },
  create(payload) {
    return axios.post(API_URL, payload, { headers: buildHeaders() });
  },
  update(id, payload) {
    return axios.put(`${API_URL}${id}`, payload, { headers: buildHeaders() });
  },
  delete(id) {
    return axios.delete(`${API_URL}${id}`, { headers: buildHeaders() });
  },
  bulkDelete(ids) {
    return axios.post(`${API_URL}bulk-delete`, { ids }, { headers: buildHeaders() });
  },
  nextCode() {
    return axios.get(`${API_URL}next-code`, { headers: buildHeaders() });
  },
};
